module.exports = __webpack_public_path__ + "static/media/Group1.22e5821a.png";